import * as Yup from 'yup';

const searchValidationSchema = Yup.object().shape({
    fullName: Yup.string().trim().required('Full name is required'),
    yearOfGraduation: Yup.number()
        .required('Year of graduation is required')
        .min(1900, 'Enter valid year')
        .max(new Date().getFullYear(), 'Enter valid year')
});

export default searchValidationSchema;
